var FakeCation = window.FakeCation || {};

(function (fc) {
  "use strict";

  const NAME = 'backgrounds';
  var pageManager = fc.pageManager;

  var page = pageManager.Page.create(NAME, '/' + NAME, '#' + NAME);

  page.html = '';

  page.render = function () {
    this.html = `<h1><img src="/assets/app/logo.svg" id="logo"></h1><div class="content"><p class="upper">Where to hop?</p>`+ fc.backgrounds.reduce(function (prev, current, index) {

      return prev + `<a href="/combine/${index}" style="background-image:url(${fc.backgrounds.path}${current.url})"><span></span></a>`;
    }, '') + '</div>';
    this.super.render();

    fc.fbq('Gallery');
  };

  pageManager.add(page);

}(FakeCation));
